import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {SmallTexts} from "../../enums/small-texts";

@Component({
  selector: 'app-small-texts',
  templateUrl: './small-texts.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./small-texts.component.less']
})
export class SmallTextsComponent implements OnInit {
  @Input() smallTexts!: string[];

  constructor() {
  }

  ngOnInit(): void { }

  protected readonly SmallTexts = SmallTexts;
}
